<style lang="stylus">
    .filesitem-viewonly
        position absolute
        max-width 80px
        height 24px
        left -1px
        top -1px
        padding 0 8px
        display flex
        justify-content center
        align-items center
        background linear-gradient(99deg, #67D7FF 18.03%, #0167FF 100%);
        border-radius 8px 0
        font-size 12px
        line-height 16px
        color #fff
        p
            display inline
            white-space nowrap
            text-overflow ellipsis
            overflow hidden
        &.primary
            background #017fff
    .filesitem-notes
        display block
        position absolute
        right 0
        top 0
        background #A8BED3
        border-radius 0px 6px
        font-size 12px
        line-height 16px
        color #fff
        padding 4px 8px
    .filesitem-onlyviewcover
        display none
        flex-wrap wrap
        align-content flex-start
        justify-content center
        position absolute
        left 0
        top 0
        width 196px
        height 136px
        background rgba(0, 0, 0, 0.4)
        border-radius 6px 6px 0 0
        .onlyviewcover-btn
            display flex
            justify-content center
            align-items center
            width 150px
            height 28px
            border-radius 6px
            font-size 12px
            line-height 16px
            &.vip
                background: linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
                color #402300
                font-weight 500
                cursor pointer
                user-select none
                margin-top 48px
                margin-bottom 8px
                &:hover
                    background linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), linear-gradient(90deg, #FFEF92 0%, #FFD67B 100%)
            &.white
                color #FFFFFF
                pointer-events none
                &:hover
                    color rgba(255, 255, 255, 0.5)
    .fileview-select-grid
        position absolute
        left 8px
        top 8px
        display none
        align-items center
        justify-content center
        width 24px
        height 24px
        cursor pointer
        z-index 1
        &:hover
            &:after
                display block

        &.selected
            display flex

        &:after
            display none
            content ''
            position absolute
            left 5px
            top 5px
            width 14px
            height 14px
            border 1px solid #017fff
            border-radius 2px
            pointer-events none

        .select-icon
            display inline-block
            width 16px
            height 16px
            background-color #fff
            border-radius 100%
            border 1px solid #ccc
            &:hover
                border 1px solid #017FFF
    .fileview-filetag
        position absolute
        left 8px
        top 102px
        height 22px
        padding 4px 8px
        background rgba(0, 0, 0, 0.40)
        border-radius 4px
        color #fff
        font-size 11px
        line-height 14px
        z-index 1
        pointer-events none
</style>
<template>
    <div style="position: absolute; left: 0; top: 0; width: 100%">
        <div
            class="fileview-select-grid"
            v-if="!pcSaveInput"
            :class="{ selected: isSelcted }"
            @mousedown.stop=""
            @click.stop="selectEvent(fileIndex)"
        >
            <img :src="require(`@/home/assets/pcview/check${isSelcted ? '-active' : ''}.svg`)" alt="" />
        </div>
        <div class="filesitem-viewonly primary" v-show="edit && !['recycle', 'team', 'publishFile'].includes(type) && !vip && !isSelcted">
            <p :title="$t('editor')">{{ $t("editor") }}</p>
        </div>

        <div v-if="type == 'recycle'" class="filesitem-notes">{{ $t("expireDate", { date: remainTime }) }}</div>

        <div class="filesitem-onlyviewcover" v-if="edit === false && !['recycle'].includes(type) && !isSelcted">
            <div class="onlyviewcover-btn vip" @click.stop="toBuy">{{ $t("onlyview-edit") }}</div>
            <div class="onlyviewcover-btn white">{{ $t("onlyview-view") }}</div>
        </div>
        <div class="fileview-filetag" v-if="fileTag">{{ $t(fileTag) }}</div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({})
    export default class GridFileExpand extends Vue {
        @Prop() fileSelected: Array<number>;
        @Prop() fileIndex: number;
        @Prop() fileTagStr: string;
        @Prop() type: string;
        @Prop() edit: boolean;
        @Prop() pcSaveInput: boolean;
        @Prop() remainTime: string;
        @Prop() fileTag;

        get isSelcted() {
            return this.fileSelected.includes(this.fileIndex);
        }

        selectEvent(index) {
            this.$emit("selectEvent", index);
        }
        documentClick() {
            var event = document.createEvent("MouseEvents");
            event.initMouseEvent("click", true, true, document.defaultView, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            document.body.dispatchEvent(event);
        }
        toBuy() {
            this.$openBuyPage();
        }

        beforeDestroy() {}
        //生命周期
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "tag": "标签",
    "none": "无",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "custom": "自定义",
    "read": "仅预览",
    "editor": "可编辑",
    "expireDate": "{date}天后永久删除",
    "onlyview-edit": "编辑",
    "onlyview-view": "仅预览",
    "passPublish": "已发布",
    "tag_share": "已分享"
  },
  "en": {
    "tag": "Tag",
    "none": "No",
    "waitdone": "In Process",
    "done": "Completed",
    "waitchange": "Need to be modified",
    "custom": "Customize",
    "read": "View only",
    "editor": "Editable",
    "expireDate": "Permanently deleted after {date} days",
    "onlyview-edit": "Edit",
    "onlyview-view": "Preview only",
    "passPublish": "Published",
    "tag_share": "Shared"
  },
  "fr": {
    "tag": "étiqueter",
    "none": "Rien",
    "waitdone": "Inachevé",
    "done": "Complété",
    "waitchange": "Besoin d'être modifié",
    "custom": "Personnalisé",
    "read": "Voir seulement",
    "editor": "Modifiable",
    "expireDate": "Supprimer définitivement après {date} jour(s)",
    "onlyview-edit": "Modifier",
    "onlyview-view": "Aperçu uniquement",
    "passPublish": "Publique",
    "tag_share": "Partagé"
  },
  "de": {
    "tag": "Etikette",
    "none": "Nichts",
    "waitdone": "Unfertigt",
    "done": "Gefertigt",
    "waitchange": "Bearbeitbar",
    "custom": "Benutzerdefiniert",
    "read": "Nur anschauen",
    "editor": "Editierbar",
    "expireDate": "Dauerhaft gelöscht nach {date} Tagen",
    "onlyview-edit": "Bearbeiten",
    "onlyview-view": "Nur Vorschau",
    "passPublish": "Öffentlichkeit",
    "tag_share": "Erfolgreich geteilt"
  },
  "jp": {
    "tag": "ラベル",
    "none": "なし",
    "waitdone": "未完成",
    "done": "完了",
    "waitchange": "修正予定",
    "custom": "カスタマイズ",
    "read": "閲覧のみ",
    "editor": "編集可能",
    "expireDate": "{date}日後に完全に消去",
    "onlyview-edit": "編集",
    "onlyview-view": "プレビューのみ",
    "passPublish": "公開済み",
    "tag_share": "共有しました"
  },
  "es": {
    "tag": "etiqueta",
    "none": "Nada",
    "waitdone": "Deshecho",
    "done": "Hecho",
    "waitchange": "Es necesario modificar",
    "custom": "Personalizar",
    "read": "Sólo vista",
    "editor": "Editable",
    "expireDate": "Eliminado de forma permanente después de {date} días",
    "onlyview-edit": "Editar",
    "onlyview-view": "Solo vista previa",
    "passPublish": "Público",
    "tag_share": "Compartido exitosamente"
  },
  "pt": {
    "tag": "rótulo",
    "none": "nada",
    "waitdone": "incompleto",
    "done": "Concluído",
    "waitchange": "Precisa ser modificado",
    "custom": "personalizada",
    "read": "Apenas ver",
    "editor": "Editável",
    "expireDate": "Excluído permanentemente após {date} dias",
    "onlyview-edit": "Editar",
    "onlyview-view": "Somente visualização",
    "passPublish": "Público",
    "tag_share": "Partilhado com Sucesso"
  },
  "it": {
    "tag": "etichetta",
    "none": "Niente",
    "waitdone": "Incompiuto",
    "done": "Completato",
    "waitchange": "Bisogna modificare",
    "custom": "Personalizza",
    "read": "Visualizzare solamente",
    "editor": "Modificabile",
    "expireDate": "Eliminato in modo permanente dopo {date} giorni",
    "onlyview-edit": "Modifica",
    "onlyview-view": "Solo anteprima",
    "passPublish": "Pubblico",
    "tag_share": "Condivisione Avvenuta con Successo"
  },
  "tw": {
    "tag": "標籤",
    "none": "無",
    "waitdone": "未完成",
    "done": "已完成",
    "waitchange": "需修改",
    "custom": "自定義",
    "read": "僅查看",
    "editor": "可編輯",
    "expireDate": "{date}天后永久删除",
    "onlyview-edit": "編輯",
    "onlyview-view": "僅供預覽",
    "passPublish": "已公開",
    "tag_share": "已分享"
  },
  "kr": {
    "tag": "태그",
    "none": "없음",
    "waitdone": "미완성",
    "done": "완료",
    "waitchange": "수정 필요함",
    "custom": "태그 지정",
    "read": "보기만 가능",
    "editor": "편집 가능",
    "expireDate": "{date}天后永久删除",
    "onlyview-edit": "편집",
    "onlyview-view": "미리 보기 전용",
    "passPublish": "공개 파일",
    "tag_share": "공유 완료"
  },
  "id": {
    "tag": "Tag",
    "none": "Tidak",
    "waitdone": "Sedang Diproses",
    "done": "Selesai",
    "waitchange": "Perlu dimodifikasi",
    "custom": "Kustomisasi",
    "read": "Hanya lihat",
    "editor": "Edit",
    "expireDate": "{date}天后永久删除",
    "onlyview-edit": "Edit",
    "onlyview-view": "Pratinjau saja",
    "passPublish": "Publik",
    "tag_share": "Berhasil Dibagikan"
  }
}
</i18n>
